import { createScanUiContextRegistry } from '../utils/createScanUiContextRegistry.util';

export const SCAN_UI_CONTEXT_REGISTRY = createScanUiContextRegistry();
